import request from '../request'
import { BotModel, BotSettings } from '../../model/bot.model'
// import axios from 'axios'

/** 查询我的bot */
export const getMyBots = async (): Promise<{ data: BotModel[] }> => {
    const url = '/wulai/store/bot/list'
    return request.get(url)
}

interface GetStoreBotsProps {
    policy: 1 | 2 // 1 私密模式 2 公开模式
    gift_code?: string
    bot_type?: 'KNOWLEDGE' | 'SKILL'
}
/** 搜索商店机器人 */
export const getStoreBots = async (
    data: GetStoreBotsProps
): Promise<{ data: BotModel[] }> => {
    const url = '/wulai/store/bot/search'
    return request.get(url, {
        params: data,
    })
}

interface UpdateInstalledBotStatusRequest {
    bot_id: string
    status: number
}
/** 更新已安装的机器人状态 */
export const updateInstalledBotStatus = (
    data: UpdateInstalledBotStatusRequest
) => {
    const url = '/wulai/store/bot/install/status'
    return request.post(url, data)
}

interface GetBotLockedKnowledgesResponse {
    data: {
        [key: string]: string
    }
}
/** 获取已锁定的知识点列表 */
export const getBotLockedKnowledges = (
    bot_id: string
): Promise<GetBotLockedKnowledgesResponse> => {
    const url = '/wulai/store/bot/knowledge/lock/by_user'
    return request.get(url, {
        params: { bot_id },
    })
}
/** 安装机器人 */
export const installStoreBot = (bot_id: string) => {
    const url = '/wulai/store/bot/install'
    return request.post(url, {
        bot_id,
    })
}

/** 移除用户机器人 */
export const botRemove = (botId: string) => {
    const url = '/wulai/store/bot/remove'
    return request.post(url, {
        bot_id: botId,
    })
}
// 获取微信收取那二维码
interface WechatyQrcode {
    wechaty_qrcode_url: string
}
export const getWechatQrcode = (): Promise<WechatyQrcode> => {
    const url = '/wechaty/app/qrcode'
    return request.get(url)
}
// 查询机器人设置
export const getWechatBotSettings = (): Promise<BotSettings> => {
    const url = '/wechaty/app/settings'
    return request.get(url)
}

// 解绑微信机器人
export const unbindWechatBot = () => {
    const url = '/wechaty/app/bot'
    return request.delete(url)
}

// 解绑管理员
export const unbindBotAdmin = () => {
    const url = '/wechaty/app/user'
    return request.delete(url)
}
// 查询机器人扫码登录状态
export const getScanStatus = () => {
    const url = '/wechaty/app/scan_status'
    return request.get(url)
}

export interface ContactObject {
    uid: string
    name: string
    describe: string
    head_url: string
    reply_object_type: string
}

// 获取回复对象列表
export type ObjectType = 'FRIEND' | 'GROUP'
export const getReplyObjects = (
    type: ObjectType
): Promise<{ wechaty_reply_object_list: ContactObject[] }> => {
    const url = '/wechaty/reply/object'
    return request.get(url, {
        params: {
            reply_object_type: type,
        },
    })
}

export interface GetContactsParams {
    keyword?: string
    contacts_type: ObjectType
}
// 读取联系人
export const getContacts = (
    params: GetContactsParams
): Promise<{ wechaty_contacts_list: ContactObject[] }> => {
    const url = '/wechaty/contacts'
    return request.get(url, {
        params,
    })
}

interface UpdateReplyObjectsParams {
    reply_object_type: ObjectType
    wechaty_reply_object_list: { uid: string }[]
}
// 更新回复对象列表
export const updateReplyObjects = (params: UpdateReplyObjectsParams) => {
    const url = '/wechaty/reply/object'
    return request.post(url, params)
}
// 读取机器人设置
export type FrienReplyObjectType = 'NO_FRIEND' | 'FRIEND_LIST' | 'FRIEND_ALL'
export type GroupReplyObjectType = 'NO_GROUP' | 'GROUP_LIST' | 'GROUP_ALL'
export interface BotReplySettings {
    friend_reply_object_type?: FrienReplyObjectType
    group_reply_object_type?: GroupReplyObjectType
    bot_open_time?: string
    bot_close_time?: string
}
// 获取回复设置
export const getBotReplySettings = (): Promise<BotReplySettings> => {
    const url = '/wulai/store/bot/settings'
    return request.get(url)
}
// 更新回复设置
export const updateBoReplySettings = (settings: BotReplySettings) => {
    const url = '/wulai/store/bot/settings'
    return request.post(url, settings)
}

export const postUserAction = (
    action: 'wechaty_refresh' | 'wechaty_unbind' | 'wechaty_reload'
) => {
    const url = '/wulai/store/user/action'
    return request.post(url, {
        action,
    })
}

// 获取新闻机器人设置

export const getNewsBotSettings = () =>
    request.get('/wulai/store/bot/news/settings')

// 获取新闻机器人设置列表
export const getNewsBotSettingList = () =>
    request.get('/wulai/store/bot/news/settings')

// 移除机器人设置
export const removeNewsBotSet = (id: string) =>
    request.post('/wulai/store/botnews/settings/remove', { id })

// 新增或者修改机器人
export const setNewsBotSettings = (data) =>
    request.post('/wulai/store/bot/news/settings', data)

// 获取消息推送设置列表

export const getPushServiceSettings = () =>
    request.get('/wulai/store/bot/msg_publish_bot/settings')

export const delPushServiceSetting = (id: string) =>
    request.post('/wulai/store/botmsg_publish_bot/settings/remove', { id })

export const savePushServicesItem = (data: any) =>
    request.post('/wulai/store/bot/msg_publish_bot/settings', data)

// 解绑微信公众号
export const unbindWx = async () => {
    const url = '/wx/unlink'
    return request.delete(url)
}

// 日程提醒设置

// 读取机器人日程提醒
export const getAlertList = () => {
    const url = '/wulai/store/bot/alert/settings'
    return request.get(url)
}
// 更新机器人日程提醒
export const updateAlert = (params) => {
    const url = '/wulai/store/bot/alert/settings'
    return request.post(url, params)
}
// 删除机器人日程提醒
export const deleteAlert = (id) => {
    const url = `/wulai/store/bot/alert/settings?alert_id=${id}`
    return request.delete(url)
}
